import axios from 'axios';
import store from '@/store/index.js';
import router from '@/router/index.js';
import Vue from 'vue';

export const baseInstanceAxios = axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

const isAxiosHandlerEnabled = (config = {}) => {
    //return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled
    return Object.prototype.hasOwnProperty.call("handlerEnabled") && !config.handlerEnabled
        ? false
        : true;
};

const requestAxiosHandler = request => {
    if (isAxiosHandlerEnabled(request)) {
        request.headers['Content-Type'] = 'application/json';
        request.headers['Authorization'] = 'Bearer ' + store.state.authToken;
    }
    return request;
};

const successAxiosHandler = response => {
    if (isAxiosHandlerEnabled(response.config)) {
        // Handle responses
    }
    return response;
};

const errorAxiosHandler = error => {
    if (isAxiosHandlerEnabled(error.config)) {
   
        if (error.response.status === 401) {

            let name = store.state.is_teacher ? "teacher/login" : "student/login";
            router.push({ name });
            //const originalRequest = error.config;
            //INTERCAMBIAR TOKEN
			/*
            axios
                .get(
                    process.env.VUE_APP_API_URL +
                        '/api/v1/auth/refresh-auth-token/',
                    {
                        params: {
                            refresh_token: store.state.refresh_token
                        }
                    }
                )
                .then(response => {
                    var data = response.data;
                    console.log(data);
                    if (data.isValid) {
                        if (data.data.error == null) {
                            store.commit(
                                'mutateAuthToken',
                                data.data.access_token
                            );
                            store.commit(
                                'mutateRefreshToken',
                                data.data.refresh_token
                            );

                            window.location.reload(true);
                            //return axios(originalRequest)
                        } else {
                            router.push({ name: 'login' });
                        }
                    } else {
                        router.push({ name: 'login' });
                    }
                });
			*/
        } else if (
            error.response.status == 403 &&
            error.response.status == 404
        ) {
            //router.push({ name: 'login' });
        } else if (error.response.status === 500) {
            Vue.prototype.$snotify.error(
                'Lo sentimos,hubo un error en el servidor'
            );
        }
    }
    return Promise.reject({ ...error });
};

// Add interceptors
baseInstanceAxios.interceptors.request.use(request =>
    requestAxiosHandler(request)
);

baseInstanceAxios.interceptors.response.use(
    response => successAxiosHandler(response),
    error => errorAxiosHandler(error)
);
